//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { EmailReportTopic } from '@account-settings/redux/emailReports/emailReportsConstants';
import { IReportContent } from '@account-settings/redux/emailReports/emailReportsModel';

export const displayReportContent = (
  reportContent: IReportContent,
  // TODO: PD-326016 - Remove feature flag after release
  isVibeBrandingSunsetEnabled: boolean,
  isDeleting?: boolean,
): string => {
  const res = [];
  if (reportContent.curalateExperiences) {
    // TODO: PD-326016 - Remove feature flag after release
    res.push(
      isVibeBrandingSunsetEnabled
        ? 'Commerce Experiences'
        : 'Vibe Commerce Experiences',
    );
  }
  if (reportContent.instagramInsights) {
    res.push('Instagram Insights');
  }
  if (reportContent.facebookInsights) {
    res.push('Facebook Insights');
  }
  if (reportContent.tiktokInsights) {
    res.push('TikTok Insights');
  }
  if (isDeleting) {
    return res.length > 2
      ? `${res[0] ?? ''}, ${res[1] ?? ''}, and ${res[2] ?? ''}`
      : res.join(' and ');
  }

  return res.join(', ');
};

export const displayTopic = (topic: string): string => {
  return topic === EmailReportTopic.INSIGHTS_WEEKLY ? 'Weekly' : 'Monthly';
};

export const mapStringToTopic = (topic: string): EmailReportTopic => {
  return topic === EmailReportTopic.INSIGHTS_WEEKLY
    ? EmailReportTopic.INSIGHTS_WEEKLY
    : EmailReportTopic.INSIGHTS_MONTHLY;
};
